import React from 'react'
import PropTypes from 'prop-types'

import { Wrapper, Content } from './styles'

export default function MinimalLayout({ children }) {
  return (
    <Wrapper>
      <Content>{children}</Content>
    </Wrapper>
  )
}

MinimalLayout.propTypes = {
  children: PropTypes.element.isRequired,
}
